<template>
  <div>
    <index-card :loading="loading">
      <template slot="header">
        <div>
          <v-btn text icon large @click="$router.push({name: 'Home'})" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
          <v-btn color="white" class="ml-1 blue-grey--text elavation-0 font-weight-bold" @click="$router.push({name:'CreateSuppliers'})" center>
            <v-icon small left>mdi-plus</v-icon>Adicionar Fornecedores
          </v-btn>
        </div>
        <div class="headline white--text">Produtos <v-icon class="white--text">mdi-package-variant-closed</v-icon></div>
      </template>
      <template slot="subheader">
        <div class="products-list-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquise.."
            :extra-filters-count="1"
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          >
            <template v-slot:extra-filters>
              <v-col cols="12" md="6">
                <v-select
                  v-model="status_filter"
                  :items="statusOptions"
                  outlined
                  dense
                  hide-details="auto"
                  prepend-inner-icon="mdi-list-status"
                  label="Status"
                />
              </v-col>
            </template>
          </filter-data>
        </div>
      </template>
      <template slot="data_table">

        <v-card v-if="!loading">
          <v-card-text>
            <v-data-table 
              :headers="headers" 
              :items="filteredProducts"    
              :search="search" 
              style="max-height: 75vh; overflow-y: auto"
              class="mx-3"
              mobile-breakpoint="1"
            >
              <template v-slot:item.status_name="{item}" class="text-xs-center">
                <v-tooltip top>
                  <template v-slot:activator="{on}"  v-if="item.status_name.includes('Act')">
                    <v-icon v-on="on" color="success" class="ml-n4">mdi-check</v-icon>
                  </template>
                  
                  <template v-slot:activator="{on}" v-else-if="item.status_name.includes('Inact')">
                    <v-icon v-on="on" color="error" class="ml-n4">mdi-close</v-icon>
                  </template>
                  <span v-if="item.status_name.includes('Act')"> Produto ativo </span>
                  <span v-else-if="item.status_name.includes('Inact')"> Produto inativo </span>
                </v-tooltip>
              </template>
              
              <template v-slot:item.status_update="{item}" class="text-xs-center">
                
                <v-tooltip top>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" color="primary" v-on="on" @click="updateProductStatus(item)" small>{{ item.status_id === 1 ? 'Desabilitar' : 'Habilitar' }}</v-btn>
                  </template>
                  <span> Habilitar/Desabilitar produto </span>
                </v-tooltip>
              </template>
                
              <template v-slot:item.actions="{item}" class="text-xs-center">
                
                <v-tooltip top>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" color="primary" v-on="on" icon @click="$router.push({name: 'EditProduct', params: {id: item.id}})" class="ml-n4"><v-icon>mdi-pencil</v-icon></v-btn>
                  </template>
                  <span> Editar produto </span>
                </v-tooltip>

                <!-- <v-tooltip top>
                  <template v-slot:activator="{on, attrs}">
                    <v-btn v-bind="attrs" v-on="on" icon class="pl-1" @click="$router.push({name: 'EditProductComission', params: {id: item.id}})"><v-icon>mdi-briefcase-edit</v-icon></v-btn>
                  </template>
                  <span> Editar comissões </span>
                </v-tooltip> -->
              </template>
              <template v-slot:no-data>
                <v-alert :value="true" type="warning" icon="mdi-alert" class="mt-3 black--text">
                  Nenhum produto a ser exibido.
                </v-alert>
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" type="error" icon="mdi-alert" class="mt-3">
                  Não foi possível encontrar "{{ search }}" nos produtos.
                </v-alert>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
            
        <router-view></router-view>
        <dialog-loading v-if="saving" loadingText="Atualizando status do produto"></dialog-loading>
      </template>
    </index-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Api from '@/api/index';

export default {
  name: 'ProductsList',
  components: {
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      search: '',
      status_filter: true,
      statusOptions: [
        { text: 'Ativos', value: true },
        { text: 'Inativos', value: false },
      ],
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Segmento', value: 'segment_name', align: 'center' },
        { text: 'Código', value: 'fn_reference', align: 'center' },
        { text: 'Status', value: 'status_name', align: 'center' },
        { text: 'Atualizar Status', value: 'status_update', align: 'center' },
        { text: 'Ação', value: 'actions', align: 'center' },
      ],
      products: [],
      loading: true,
      segments_map: {},
      showOnlyNewProducts: true,
      saving: false,
    }
  },
  methods: {
    getData(){
      this.getProducts()
    },  
    getProducts(){
      this.loading = true
      Api.SupplierV2.index('products', {status_id: this.showOnlyNewProducts ? 1 : 2, without_ppl: true}).then(r=> this.products = r.data ).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
      this.showOnlyNewProducts = this.status_filter
    },
    updateProductStatus(item) {
      console.log(item)
      this.swallConfirmation({
        title: 'Deseja atualizar o status do produto?',
        icon: 'question',
      }).then( confirmed =>{
        if(confirmed) {
          this.saving = true
          const product = {
            id: item.id,
            status_id: item.status_id === 1 ? 2 : 1
          }
          Api.Supplier.updateOnlyProduct(product).then((r) =>{
            let idx = this.products.findIndex(el => { return el.id == r.data.data.attributes.id })

            this.products[idx].status_id = r.data.data.attributes.status_id
            this.products[idx].status_name = r.data.data.attributes.status_name

            this.addNotification({type: 'success',  msg: `Status do produto atualizado com sucesso.`})
          }).catch((err) =>{
            this.addNotification({type: 'error',  msg: `Erro: ${err}`})
          }).finally(() => {
            this.saving = false
          })
        }
      })
    },
    ...mapActions({
    })
  },
  computed: {
    filteredProducts() {

      return this.products

    },
    ...mapState({
      profile: state => state.User.oneUser,
    })
  },
  watch: {
    '$route.params'(nv){
      if(nv.product_updated_id){
        let idx = this.products.findIndex(el => { return el.id == nv.product_updated_id })
        this.products[idx].name = nv.name
        this.products[idx].segment_id = nv.segment_id
        this.products[idx].segment_name = nv.segment_name
      }
    },  
    showOnlyNewProducts(nv, ov) {
      console.log(nv)
      if(nv != ov) {
        this.getData();
      }
    }
  },
  mounted () {
    this.getData();
  },
}
</script>

<style scoped>
.products-list-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.products-list-filters >>> .filter-data-card {
  width: 100%;
}
</style>
